module.exports = __webpack_public_path__ + "static/media/banner.0e91e871.png";